exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ListGridCoverPhoto-displayGrid-1-0Hn {\r\n\tdisplay: grid;\r\n\tgrid-template-columns: 50% 50%;\r\n}\r\n\r\n.ListGridCoverPhoto-firstImage-7_XtN {\r\n\theight: 500px;\r\n    margin-right: 10px;\r\n\tborder-radius: 12px 0px 0px 12px;\r\n}\r\n\r\n.ListGridCoverPhoto-secondImage-1Pc1p {\r\n\theight: 270px;\r\n    margin-bottom: 10px;\r\n\tborder-radius: 0px 12px 0px 0px;\r\n}\r\n\r\n.ListGridCoverPhoto-thiredImage-3Xupo {\r\n\theight: 220px;\r\n    margin-right: 5px;\r\n}\r\n\r\n.ListGridCoverPhoto-fouthImage-2LuEi {\r\n\theight: 220px;\r\n    margin-left: 5px;\r\n\tborder-radius: 0px 0px 12px 0px;\r\n}", ""]);

// exports
exports.locals = {
	"displayGrid": "ListGridCoverPhoto-displayGrid-1-0Hn",
	"firstImage": "ListGridCoverPhoto-firstImage-7_XtN",
	"secondImage": "ListGridCoverPhoto-secondImage-1Pc1p",
	"thiredImage": "ListGridCoverPhoto-thiredImage-3Xupo",
	"fouthImage": "ListGridCoverPhoto-fouthImage-2LuEi"
};